getActiveProductPlanRateId